export enum SceneKeys {
  Boot = 'boot',
  Menu = 'menu',
  Game = 'game',
  GameOver = 'game-over',
}

export enum TextureKeys {
  Background = 'background',
  ChaosSheet = 'chaos-sheet',
  ObstacleSheet = 'obstacle-sheet',
  PaperPanel = 'paper-panel',
  AimDot = 'aim-dot',
}

export enum AnimationKeys {
  SquirrelFly = 'squirrel-fly',
}

export enum ChaosFrame {
  SquirrelHappy = 0,
  SquirrelTumble = 1,
  SquirrelTriumph = 2,
  SquirrelAnnoyed = 3,
  Cannon = 4,
  Whoopee = 5,
  Banana = 6,
  Fan = 7,
  Couch = 8,
  Duck = 9,
  Soda = 10,
  Lunchbox = 11,
}

export enum ObstacleFrame {
  Mud = 0,
  Laundry = 1,
  Taxes = 2,
  Gum = 3,
  Rake = 4,
  Castle = 5,
  YardSale = 6,
  Starburst = 7,
}
